import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedDate } from 'react-intl';
import { Grid, IconButton, ListItem, ListItemText } from '@mui/material';

import { type ItemLayoutProps } from 'app/main/components/GridList';
import { HTMLRenderer, Icon, ImageAvatar, showDeleteDialog, Text, Utils } from 'app/main/components';
import { showAddNotesDialog } from './NotesAddDialog';

export default function NotesListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();

	const updateNote = () => {
		dispatch(
			showAddNotesDialog({
				model: props.model,
				isUpdate: true,
				updateRefresh: props.buttonProps.updateRefresh
			})
		);
	};

	const deleteNote = () =>
		dispatch(
			showDeleteDialog({
				module: 'notes',
				id: props.model.note_uid,
				hardDelete: true,
				replace: false,
				updateRefresh: props.buttonProps.updateRefresh
			})
		);

	return (
		<ListItem className="last:border-b-0" divider>
			<ListItemText
				primary={
					<Grid container justifyContent="space-between" spacing={1}>
						<Grid>
							<Grid container justifyContent="space-between" alignItems="center" spacing={2}>
								{props.width >= 600 && (
									<Grid>
										{/* AVATAR */}
										<ImageAvatar
											dimensions={36}
											module="users"
											uid={props.model.note_user_created_uid}
											avatar={props.model.user_avatar}
											initials={props.model.user_title_initials}
										/>
									</Grid>
								)}
								<Grid>
									{/* USER */}
									<Text
										className="font-600"
										variant="subtitle2"
										to={{ module: 'users', uid: props.model.note_user_created_uid }}
									>
										{props.model.user_title}
									</Text>
									{/* CREATION DATE */}
									<Text className="font-400" variant="subtitle2" color="text.secondary">
										<FormattedDate
											value={Utils.parseDate(props.model.note_d_created)?.toDate()}
											year="numeric"
											month="long"
											day="numeric"
											hour="numeric"
											minute="numeric"
											second="numeric"
										/>
									</Text>
								</Grid>
							</Grid>
						</Grid>
						<Grid>
							{/* BUTTONS */}
							<IconButton onClick={updateNote}>
								<Icon icon="edit" />
							</IconButton>
							<IconButton onClick={deleteNote} edge="end">
								<Icon icon="delete" />
							</IconButton>
						</Grid>
						<Grid size={12}>
							{/* NOTE TEXT */}
							<HTMLRenderer value={props.model.note_descriptionhtml} />
						</Grid>
					</Grid>
				}
			/>
		</ListItem>
	);
}
